
import { mapGetters } from "vuex";
import Highlighter from "vue-highlight-words";

export default {
  components: {
    Highlighter,
  },

  data() {
    return {
      loading: false,

      timerCity: null,

      timerDate: null,
    };
  },

  async fetch({ store }) {
    await store.dispatch("website-news/retirieveWebsiteNews");
    await store.dispatch("manager/news/retrieveCityForWebsite");
  },
  head() {
    return {
      title: this.seoTexts?.title || this.$t("seo.news.title"),

      link: [
        {
          rel: "canonical",
          href: `${this.$config.baseUrlApp}/escorts-news`,
        },
      ],

      meta: [
        {
          hid: "description",
          name: "description",
          content:
            this.seoTexts?.description || this.$t("seo.news.description"),
        },
        {
          hid: "og:description",
          name: "og:description",
          content:
            this.seoTexts?.description || this.$t("seo.news.og-description"),
        },
        {
          hid: "og:title",
          name: "og:title",
          content: this.seoTexts?.title || this.$t("seo.news.og-title"),
        },
      ],

      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(this.jsonldNewsColection),
        },
      ],

      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    ...mapGetters({
      newsList: "website-news/getNewsList",
      lastPage: "website-news/getLastPage",
      amountNews: "website-news/getAmountNews",
      searchText: "website-news/getSearchText",
      isMobile: "global/getMobileStatus",
      cityCodes: "manager/news/getSityForWebsite",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      seoTexts: "global/getSeoTexts",
    }),

    h1() {
      return this.seoTexts?.h1 || this.$t("nav.news");
    },

    filterObj() {
      const districts =
        this.filtersList?.districts?.filter(
          (district) => district.city_id == this.currentCity.id
        ) || [];

      return {
        district: {
          items: districts,
          title: this.$t("area"),
        },
      };
    },

    percentage() {
      return this.newsList ? (this.newsList.length * 100) / this.amountNews : 0;
    },

    customDatesStartFilter() {
      if (this.newsList && this.newsList.length) {
        return this.newsList[this.newsList.length - 1].created_at;
      } else return "";
    },

    jsonldNewsColection() {
      return {
        "@context": "http://schema.org",
        "@type": "ItemList",
        url: `${this.$config.baseUrlApp}/escorts-news`,
        name: "Emiratesescort " + this.$t("nav.news"),
        itemListElement: this.newsList.map((news, index) => {
          return {
            "@type": "ListItem",
            position: index + 1,
            item: {
              "@type": "NewsArticle",
              headline: news.title,
              datePublished: news.created_at,
              dateModified: news.updated_at,
              description: news.description,
            },
          };
        }),
      };
    },
  },

  beforeDestroy() {
    this.$store.commit("website-news/resetFilters");
  },

  methods: {
    setDate(dates) {
      clearTimeout(this.timerDate);

      this.$store.commit("website-news/setDatesSearch", dates);

      this.timerDate = setTimeout(() => {
        this.$store.dispatch("website-news/retirieveWebsiteNews");
      }, 1000);
    },

    async setDistricts(district) {
      this.$store.commit("website-news/setDistrictFilter", district);
      this.timerDateId = setTimeout(() => {
        this.$store.dispatch("website-news/retirieveWebsiteNews");
      }, 1000);
    },

    setSearchFilter(name, value) {
      clearTimeout(this.timerSearchText);

      this.$store.commit("website-news/setSearchText", value);

      this.timerSearchText = setTimeout(() => {
        this.$store.dispatch("website-news/retirieveWebsiteNews");
      }, 1000);
    },

    setFilter(value) {
      clearTimeout(this.timerCity);

      this.$store.commit("website-news/setDistrictFilter", value.district);

      this.timerCity = setTimeout(() => {
        this.$store.dispatch("website-news/retirieveWebsiteNews");
      }, 1000);
    },

    async showMoreNews() {
      this.loading = true;

      await this.$store.dispatch("website-news/uploadWebsiteNews");

      this.loading = false;
    },

    // newsFilterModifier() {
    //   this.$store.commit("global/setNewsFilter");
    // },
  },
};
